import React from "react";

import { useWorkOSAuth } from "@worktango/d2c-service/workOSReact";

import { Button, Text } from "@kazoohr/confetti";
import { doNothing } from "@kazoohr/helpers";

import { useGetCurrentUserQuery } from "../../generated/apiHooks";

import styles from "./viewingAsBar.scss";

export function ViewingAsBar() {
  const { user } = useWorkOSAuth();
  const { data } = useGetCurrentUserQuery({
    skip: !user,
    onError: doNothing, // Handled elsewhere
  });
  const currentUser = data?.currentUser;

  if (!currentUser?.organization || !currentUser?.organizationOverridden) {
    return null;
  }

  const handleExit = () => {
    const url = new URL(window.location.href);
    url.searchParams.set("overrideOrganizationId", "");
    window.location.href = url.toString();
  };

  return (
    <div className={styles["viewing-as-bar"]}>
      <div className={styles["viewing-as-content"]}>
        <Text>Accessing organization {currentUser.organization.name}</Text>
        <Button
          variant="secondary"
          onClick={handleExit}
          aria-label="Exit organization override"
        >
          Exit
        </Button>
      </div>
    </div>
  );
}
